

<header class="external-content-header">
  <a [href]="hostName" class="image-link">
    <img [src]="'logo' | asset | async" class="brand-logo">
  </a>
  <nav class="desktop-header-nav">
    <ul class="nav-list">
      <li *ngFor="let navItem of navItems" [ngSwitch]="navItem.type">
        <external-content-nav-dropdown
          *ngSwitchCase="'dropdown'"
          [navItem]="navItem"
          [isSidebarItem]="false"
        ></external-content-nav-dropdown>
        <a *ngSwitchCase="'external'" class="nav-link" [href]="navItem.url">{{ navItem.text }}</a>
        <a *ngSwitchCase="'internal'" class="nav-link" [routerLink]="navItem.routerLink">{{ navItem.text }}</a>
      </li>
      <ng-container [ngTemplateOutlet]="navigationCtas"></ng-container>
    </ul>
  </nav>

  <nav class="mobile-header-nav">
    <a textCta [underlineOnHover]="true" href="tel:215-607-8942" class="phone-number">
      <fa flattenBefore name="phone" class="phone-icon"></fa><span class="d-none d-xs-inline">(215) 607-8942</span>
    </a>
    <button class="menu-btn" (click)="snav.toggle()" aria-label="menu">
      <fa class="header-icon" name="bars"></fa>
    </button>
  </nav>
</header>

<mat-sidenav-container class="dash-theme external-content-sidenav-container">
  <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'" [fixedInViewport]="true" [fixedTopGap]="HEADER_HEIGHT">
    <nav>
      <ul class="nav-list">
        <li *ngFor="let navItem of navItems" [ngSwitch]="navItem.type">
          <external-content-nav-dropdown *ngSwitchCase="'dropdown'" [navItem]="navItem"></external-content-nav-dropdown>
          <a *ngSwitchCase="'external'" class="nav-link" [href]="navItem.url">{{ navItem.text }}</a>
          <a *ngSwitchCase="'internal'" class="nav-link" [routerLink]="navItem.routerLink">{{ navItem.text }}</a>
        </li>
        <ng-container [ngTemplateOutlet]="navigationCtas"></ng-container>
      </ul>
    </nav>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="sidenav-container">
      <ng-content></ng-content>
    </div>
  </mat-sidenav-content>

</mat-sidenav-container>

<ng-template #navigationCtas>
  <li class="cta-list-item">
    <a class="nav-cta nav-cta-signup" [routerLink]="['/questionnaire']">Get Started</a>
  </li>
  <li class="cta-list-item">
    <a class="nav-cta nav-cta-log-in" [routerLink]="['/login']">Log In</a>
  </li>
</ng-template>
